import type { Validator } from './types';

export function makeMinValueValidator(minValue: number, message: string): Validator<string> {
    return (value?: string) => (!value || Number(value) >= minValue ? undefined : message);
}
